import { supabase } from "./supabase";

export async function logActivity({
  action,
  entityType,
  entityId = null,
  entityLabel = "",
  details = {},
}) {
  try {
    const { data } = await supabase.auth.getUser();
    const user = data?.user;

    await supabase.from("activity_logs").insert([
      {
        user_id: user?.id || null,
        user_email: user?.email || "Unknown user",
        action,
        entity_type: entityType,
        entity_id: entityId ? String(entityId) : null,
        entity_label: entityLabel || "",
        details,
      },
    ]);
  } catch (error) {
    console.error("Activity log failed:", error);
  }
}
